import { useSelector } from 'react-redux';

import { Typography } from '@alfalab/core-components/typography';
import { createCn } from 'bem-react-classname';

import { changeDateFormat } from '@utils/helpers';
import { RootState } from '@utils/types';

import './InfoForTransfer.scss';

const cn = createCn('content');

export const InfoForTransfer: React.FC = () => {
    const { name, comment, type, ownerName, goal, dueDate } = useSelector(
        (state: RootState) => state.request.initializeApplicationRequest.result
    );

    return (
        <div className={cn()}>
            <Typography.Text view='primary-medium' color='secondary' tag='p'>
                {type === 'MONEY_POOL' ? 'Сбор денег' : 'Разделение чека'}
            </Typography.Text>
            <Typography.TitleResponsive view='medium' tag='div'>
                {`«${name}»`}
            </Typography.TitleResponsive>
            <Typography.Text view='primary-medium' tag='p'>
                {goal && +goal.value ? `${goal.value / goal.minorUnits} ₽` : null}
                {dueDate ? ` · До ${changeDateFormat(dueDate)}` : null}
                <br />
                {type === 'MONEY_POOL' && comment ? comment : null}
            </Typography.Text>

            <Typography.Text view='primary-medium' color='secondary' tag='p'>
                Организатор — {ownerName}
            </Typography.Text>
        </div>
    );
};
